import { SelectOption } from '@globaleris/ui.library'
import {
  EnumCommodity,
  EnumSubtipoSujeto,
  EnumTipoCicloFacturacion,
  EnumTipoPeaje,
  EnumTipoSujeto
} from '../../..'
import { enumEnumToValueNumber, enumEnumToValueString } from '../../../../helpers'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { SubjectModel } from '../../../../pages/clients/clients.model'
import {
  ChangeContractOwnershipModel,
  NewContractModel,
  PatchContractBatchRequest,
  PatchContractSuppliesBatchRequest,
  RevertChangeOwnershipModel,
  TerminateContractOwnershipModel
} from '../../../../pages/contracts/contracts.model'
import { Limit } from '../../../../pages/flexibility/flexibility.Model'
import { UseModelPatch } from '../../../../pages/uses/uses.model'
import { getActiveCompany, getAppConfigurationValue } from '../../../../redux'
import { ContractProductAPIModel, HandleBatchResponse } from '../../../Pioneer/model/Contracts'
import AxiosInstance from '../../../http-config'
import { EnumClientTypes } from '../../enums/enumClientTypes'
import {
  ActiveContractModelResponse,
  CUPSModel,
  ContractModel,
  PaymentMethodTypeModel,
  UseModel
} from '../../model/contracts'
import {
  AnnexedContractModel,
  AnnexedContractModelPatchRequest,
  AnnexedContractModelPostRequest,
  ContractOrdersModel,
  ContractOrdersRequestModel,
  ContractQuantity,
  ContractQuantityRequest,
  NewContractQuantity,
  ProductSelectOption
} from './model/contracts'

export const apiFetchContractByID = async (contractID: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Contracts/GetContract?contractID=${contractID}`
    `${apiSuffixUrl}/api/Contracts/GetContract?contractID=${contractID}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchContractsBySubjectID = async (subjectID: number): Promise<ContractModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/GetContractsBySubject?subjectID=${subjectID}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchContractProductsBySubjectID = async (
  subjectID: number
): Promise<ContractProductAPIModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchContractProductsBySubject?subjectID=${subjectID}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchProductsByContractID = async (
  contractID: number
): Promise<ContractProductAPIModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchProductsByContract?contractID=${contractID}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchProductsBySettlementID = async (
  settlementGroupID: number
): Promise<ContractProductAPIModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchProductsBySettlementGroup?settlementGroupId=${settlementGroupID}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetCapacitiesOrATRForContract = async (
  contractID: number
): Promise<ContractModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Contracts/GetContractATRorCapacityByContractID?contractID=${contractID}`
    `${apiSuffixUrl}/api/Contracts/GetContractATRorCapacityByContractID?contractID=${contractID}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetContractByCode = async (contractCode: string): Promise<ContractModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/GetContractsByCode?contractCode=${contractCode}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetContractBySubjectId = async (subjectId: number): Promise<ContractModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}api/Contracts/GetContractsBySubject?subjectID=${subjectId}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiSaveContract = async (contract: NewContractModel): Promise<ContractModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59923'

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Contracts/PostContract`, contract).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiUpdateContract = async (
  request: PatchContractBatchRequest
): Promise<HandleBatchResponse> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/Contracts/UpdateContract`,
    `${apiSuffixUrl}/api/Contracts/UpdateContract`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPatchContract = async (request: ContractModel): Promise<ContractModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/Contracts/PatchContract`,
    `${apiSuffixUrl}/api/Contracts/PatchContract`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiUpdateContractSupplies = async (
  request: PatchContractSuppliesBatchRequest
): Promise<HandleBatchResponse> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/Contracts/NewUpdateContractSupplies`,
    `${apiSuffixUrl}/api/Contracts/NewUpdateContractSupplies`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchProductsBySubjectSubType = async (
  clientSubtype: EnumSubtipoSujeto,
  commodity: EnumCommodity
): Promise<ProductSelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const clientSubtypeString = enumEnumToValueString(EnumSubtipoSujeto, clientSubtype)

  const activeCompany = getActiveCompany()?.id

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchProductsBySubjectSubType?clientSubtype=${clientSubtypeString}&commodity=${commodity}&company=${activeCompany}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchProductsBySubjectType = async (
  clientType: EnumTipoSujeto,
  commodity?: EnumCommodity
): Promise<ProductSelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const clientTypeString = enumEnumToValueString(EnumClientTypes, clientType)
  const activeCompany = getActiveCompany()?.id

  // let query = `clientType=${clientTypeString}`
  let query = `clientType=${clientType}`

  if (commodity) {
    query += `&commodity=${commodity}`
  }

  if (activeCompany) {
    query += `&company=${activeCompany}`
  }

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchProductsBySubjectType?${query}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchProductTypeOptionsByClientType = async (
  clientType: EnumClientTypes
): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Products/fetchProductTypes?clientType=${clientType}`
  ).then(response => {
    return response.data
  })
}

export const apiFetchContractQuantitiesForContract = async (contractID: number): Promise<Limit> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/GetContractQuantitiesByContractID?contractID=${contractID}`
  ).then(response => {
    return response.data
  })

  // return await new Promise((res, rej) => {
  //   rej('')
  // })
}

export const apiFetchServices = async (clientType: EnumTipoSujeto): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchServices?clientType=${clientType}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchContractTypes = async (
  subjectType: EnumTipoSujeto,
  commodity?: EnumCommodity | null
): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const commodityNumber = commodity ? enumEnumToValueString(EnumCommodity, commodity) : null

  let url = `${apiSuffixUrl}/api/Contracts/FetchContractTypesOptions`

  url += `?subjectType=${subjectType}`

  if (commodityNumber) {
    url += `&commodity=${commodityNumber}`
  }

  return await AxiosInstance.get(url).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchTolls = async (commodity: EnumCommodity): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchTolls?commodity=${commodity}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchPressureGroup = async (commodity: EnumCommodity): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchPressureGroup?commodity=${commodity}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchBillingCycleBySubjectType = async (
  clientType: EnumTipoSujeto
): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  let paramCycle = ''

  if (
    clientType &&
    enumEnumToValueNumber(EnumTipoSujeto, clientType) === EnumTipoSujeto.Mayorista
  ) {
    paramCycle = `&cycleInvoicing=${enumEnumToValueString(EnumTipoCicloFacturacion, EnumTipoCicloFacturacion.Cuentas)}`
  }

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchBillingCycleBySubjectType?clientType=${clientType}${paramCycle}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchPaymentMethodOptions = async (): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Contracts/FetchPaymentMethodOptions`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchHoldOptions = async (): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Contracts/FetchHoldOptions`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchPaymentMethods = async (): Promise<PaymentMethodTypeModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Contracts/FetchPaymentMethods`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchATRTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Contracts/FetchATRTypes`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchActivityTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Contracts/FetchActivityTypes`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchBankingEntity = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Contracts/FetchBankingEntity`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchContractsByCups = async (
  codeCUPS: string,
  companyId: number,
  iniDate: string,
  endDate?: string
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/GetActiveContractsInPeriodByCUPS?CUPSCode=${codeCUPS}&company=${companyId}&iniDate=${iniDate}&endDate=${endDate}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchActiveContractByCups = async (
  codeCUPS: string,
  companyId: number
): Promise<ActiveContractModelResponse> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/GetActiveContractByCups?CUPSCode=${codeCUPS}&company=${companyId}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiChangeOwner = async (
  changeOwnership: ChangeContractOwnershipModel
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Contracts/ChangeOwnership`,
    changeOwnership
  ).then(
    //return await AxiosInstance.post(`https://localhost:51038/api/Contracts/ChangeOwnership`, changeOwnership).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiRevertChangeOwner = async (model: RevertChangeOwnershipModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Contracts/RevertChangeOwnership`,
    model
  ).then(
    // return await AxiosInstance.post(
    //   `https://localhost:63910/api/Contracts/RevertChangeOwnership`,
    //   model
    // ).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiTerminateContract = async (
  request: TerminateContractOwnershipModel
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Contracts/TerminateContract`, request).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchExistingCUPS = async (
  codeCUPS: string,
  commodity: EnumCommodity
): Promise<CUPSModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchExistingCUPSByCommodity?codeCUPS=${codeCUPS}&commodity=${commodity}`
  ).then(response => {
    return response.data
  })
}

export const apiGetExistingCUPSByCode = async (codeCUPS: string): Promise<CUPSModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/GetCUPSByCode?codeCUPS=${codeCUPS}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchPowerPeriodsByToll = async (toll: EnumTipoPeaje): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/FetchPowerPeriodsByToll?toll=${toll}`
  ).then(response => {
    if (response.data > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetEntityBankByIBAN = async (IBAN: string): Promise<ContractModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Contracts/GetBankEntityByIBAN?iban=${IBAN}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiCreateContractQuantityForContract = async (
  contractID: number,
  contractQuantity: NewContractQuantity
): Promise<ContractQuantity> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Contracts/CreateContractQuantitiesForContract`,
    {
      contractID,
      contractQuantity
    }
  ).then(response => {
    return response.data
  })
}

export const apiUpdateContractQuantityForContract = async (
  contractID: number,
  contractQuantity: ContractQuantityRequest
): Promise<ContractQuantity> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Contracts/UpdateContractQuantitiesForContract`,
    {
      contractID,
      contractQuantity
    }
  ).then(response => {
    return response.data
  })
}

export const apiGetClientDataByCUPS = async (
  CUPSCode: string,
  startDate: string,
  endDate: string
): Promise<SubjectModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Contracts/GetContractSubjectByCUPSCode?CUPSCode=${CUPSCode}&iniDate=${startDate}&endDate=${endDate}`
    `${apiSuffixUrl}/api/Contracts/GetContractSubjectByCUPSCode?CUPSCode=${CUPSCode}&iniDate=${startDate}&endDate=${endDate}`
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const getCUPSwithMetersAndUses = async (CUPSCode: string): Promise<CUPSModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Contracts/GetMetersAndUses?codeCups=${CUPSCode}`
    `${apiSuffixUrl}/api/Contracts/GetMetersAndUses?codeCups=${CUPSCode}`
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiCreateCupsRef = async (
  cupsID: number,
  navigationProperty: 'distribuidora' | 'elementoLogistico',
  keyID: number
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = {
    cupsID: cupsID,
    navigationProperty: navigationProperty,
    keyID: keyID
  }
  return await AxiosInstance.post(
    // `https://localhost:59923/api/Contracts/CreateCupsRef`,
    `${apiSuffixUrl}/api/Contracts/CreateCupsRef`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPostUseFromCups = async (newUse: UseModel, cupsID: number): Promise<UseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = newUse

  return await AxiosInstance.post(
    // `https://localhost:59923/api/Contracts/PostUseFromCUPS(${cupsID})`,
    `${apiSuffixUrl}/api/Contracts/PostUseFromCUPS(${cupsID})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteUseFromCups = async (useID: number, cupsID: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    // `https://localhost:59923/api/Contracts/DeleteUseFromCUPS(${cupsID})/Uses(${useID})`
    `${apiSuffixUrl}/api/Contracts/DeleteUseFromCUPS(${cupsID})/Uses(${useID})`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPatchUseFromCups = async (
  modifieduse: UseModelPatch,
  cupsID: number
): Promise<UseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = modifieduse

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/Contracts/PatchUseFromCUPS(${cupsID})/Uses(${modifieduse.id})`,
    `${apiSuffixUrl}/api/Contracts/PatchUseFromCUPS(${cupsID})/Uses(${modifieduse.id})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPostAnnexedContract = async (
  request: AnnexedContractModelPostRequest[],
  contractId: number
): Promise<AnnexedContractModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/Contracts/Contract(${contractId})/AnnexedContract`,
    `${apiSuffixUrl}/api/Contracts/Contract(${contractId})/AnnexedContract`,
    request
  ).then(response => {
    if (response.data != undefined) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPutAnnexedContract = async (
  contractId: number,
  annexedContractId: number,
  request: AnnexedContractModelPatchRequest
): Promise<AnnexedContractModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.put(
    // `https://localhost:59923/api/Contracts/Contract(${contractId})/AnnexedContract(${annexedContractId})`,
    `${apiSuffixUrl}/api/Contracts/Contract(${contractId})//AnnexedContract(${annexedContractId})`,
    request
  ).then(response => {
    if (response.data != undefined) {
      return response.data
    }
  })
}

export const apiDeleteAnnexedContract = async (
  contractId: number,
  annexedContractId: number
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    // `https://localhost:59923/api/Contracts/Contract(${contractId})/AnnexedContract(${annexedContractId})`
    `${apiSuffixUrl}/api/Contracts/Contract(${contractId})//AnnexedContract(${annexedContractId})`
  ).then(response => {
    if (response.data != undefined) {
      return response.data
    }
  })
}

export const apiGetContractOrders = async (contractId: number): Promise<ContractOrdersModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Contracts/Contract(${contractId})/ContractOrders`
    `${apiSuffixUrl}/api/Contracts/Contract(${contractId})/ContractOrders`
  ).then(response => {
    if (response) {
      return response.data
    } else {
      return [] as ContractOrdersModel[]
    }
  })
}

export const apiPostContractOrders = async (
  contractId: number,
  request: ContractOrdersRequestModel
): Promise<ContractOrdersModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/Contracts/Contract(${contractId})/ContractOrders`,
    `${apiSuffixUrl}/api/Contracts/Contract(${contractId})/ContractOrders`,
    request
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiPatchContractOrders = async (
  contractId: number,
  contractOrderId: number,
  request: ContractOrdersRequestModel
): Promise<ContractOrdersModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/Contracts/Contract(${contractId})/ContractOrders(${contractOrderId})`,
    `${apiSuffixUrl}/api/Contracts/Contract(${contractId})/ContractOrders(${contractOrderId})`,
    request
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiDeleteContractOrders = async (
  contractId: number,
  contractOrderId: number
): Promise<ContractOrdersModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    // `https://localhost:59923/api/Contracts/Contract(${contractId})/ContractOrders(${contractOrderId})`
    `${apiSuffixUrl}/api/Contracts/Contract(${contractId})/ContractOrders(${contractOrderId})`
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiCheckContractSignDateByProcedureId = async (
  procedureId: number
): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Contracts/CheckContractSignDateByProcedureId(${procedureId})`
    `${apiSuffixUrl}/api/Contracts/CheckContractSignDateByProcedureId(${procedureId})`
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}
